import Keycloak from 'keycloak-js'
import { resolveApiUrl } from '#shared/api'

const keycloak = new Keycloak({
  url: resolveApiUrl('@sd-auth') || 'http://localhost:8080',
  realm: import.meta.env.PUBLIC_KEYCLOAK_REALM || 'realm',
  clientId: import.meta.env.PUBLIC_KEYCLOAK_CLIENT_ID || 'client',
})

// @ts-expect-error Testing
window.keycloak = keycloak

export default keycloak
